module.exports = __webpack_public_path__ + "img/emptyCart.74f402c8.jpg";